export class AppSettings {
  public static version = "2.4.46";
}
